/**
 * FloView 조작 안내 줄 — 캔버스 아래에 휠 확대·끌어 이동·클릭 강조를 늘 보인다.
 * hover 나 도움말 버튼 없이도 크게 보기에서 할 수 있는 일을 알 수 있게 한다.
 * 무엇을 선택한 동안에는 강조 안내가 해제 방법(빈 곳 클릭)으로 바뀐다.
 * 클릭 강조를 끈 보기(lineage=false)에서는 그 항목을 내지 않는다.
 * 중립 leaf — pages/** 를 import 하지 않는다.
 */
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MouseOutlinedIcon from "@mui/icons-material/MouseOutlined";
import PanToolOutlinedIcon from "@mui/icons-material/PanToolOutlined";
import TouchAppOutlinedIcon from "@mui/icons-material/TouchAppOutlined";

import { FS } from "@plannel/utils/font-util";

const ICON_SX = { fontSize: 14, color: "text.secondary", flexShrink: 0 };
const TEXT_SX = { fontSize: FS.CAPTION, color: "text.secondary", lineHeight: 1.5 };

function Hint({ icon: Icon, text, kind }) {
  return (
    <Box data-flo-hint={kind} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Icon sx={ICON_SX} />
      <Typography sx={TEXT_SX}>{text}</Typography>
    </Box>
  );
}

export default function FloViewHints({ lineage = true, selected = false }) {
  const { t } = useTranslation();
  return (
    <Box data-flo-hints sx={{
      display: "flex", alignItems: "center", flexWrap: "wrap", columnGap: 2, rowGap: 0.25,
      px: 1.5, py: 0.5, borderTop: 1, borderColor: "divider", flexShrink: 0,
    }}>
      <Hint kind="zoom" icon={MouseOutlinedIcon} text={t("floViewHintZoom")} />
      <Hint kind="pan" icon={PanToolOutlinedIcon} text={t("floViewHintPan")} />
      {lineage && (
        <Hint kind={selected ? "clear" : "select"} icon={TouchAppOutlinedIcon}
              text={t(selected ? "floViewHintClear" : "floViewHintSelect")} />
      )}
    </Box>
  );
}
